export default __webpack_public_path__ + "static/media/MX-Safety-Hero-Desktop.65497511.jpg";